import { useEffect, useState } from 'react'

import { Alert, Box } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'
import { TerminatePageEmployeeReferenceContractFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import { convertDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface Props {
  form: Form
  referenceContract: TerminatePageEmployeeReferenceContractFragment
}

function ContractEndDatePicker({ form, referenceContract }: Props) {
  const field = form.get('contract_end_date')
  const [hasUserChangedValue, setHasUserChangedValue] = useState(false)

  const defaultValue = referenceContract.endsOn || null
  const defaultValueFormatted = defaultValue ? convertDate(defaultValue, 'backend', 'ui') : null

  // Set the field value synchronously if we have a default value and the current value is empty or invalid
  const isFieldUnsetOrInvalid = !field.value || field.value === 'Invalid date'
  if (defaultValueFormatted && isFieldUnsetOrInvalid) {
    field.set(defaultValueFormatted)
  }

  // Track when user changes the value
  useEffect(() => {
    if (defaultValueFormatted && field.value && field.value !== defaultValueFormatted) {
      setHasUserChangedValue(true)
    }
  }, [field.value, defaultValueFormatted])

  const shouldShowInfoMessage = referenceContract.endsOn && !hasUserChangedValue

  const handleSameDefaultDates = () => {
    if (form.values.terminated_on && !field.value) field.value = form.values.terminated_on
  }

  useEffect(() => {
    handleSameDefaultDates()
  }, [form.values])

  return (
    <>
      <DayPicker
        label={i18n.t('employees.termination.contract_end_date')}
        field={field}
        pin
        mandatory={false}
        readonly={false}
      />

      {shouldShowInfoMessage && (
        <Box paddingTop="s8">
          <Alert color="info">
            {i18n.t('employees.termination.contract_end_date_exists_info')}
          </Alert>
        </Box>
      )}
    </>
  )
}

export default observer(ContractEndDatePicker)
